//https://boost.allnetru.dev/api/documentation#/Organization
import { createApi } from '@reduxjs/toolkit/query/react';
import { UserLoginResponse } from 'lib.store/src/models-to-replace/auth';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const organization = `organization`;

/** The organization's own settings — the fields its admins manage themselves */
export interface OrganizationSettings {
  id: number;
  name: string;
  website: string | null;
  description: string | null;
  logo: string | null;
  logo_square: string | null;
  type: { id: number; name: string; translate?: string };
}

export interface OrganizationSettingsUpdate {
  name: string;
  website?: string | null;
  description?: string | null;
  logo?: string | null;
  logo_square?: string | null;
}

export const organizationApi = createApi({
  reducerPath: organization,
  baseQuery: baseQueryWithReauth,
  tagTypes: [organization],
  endpoints: (build) => ({
    getMyOrganization: build.query<{ data: OrganizationSettings }, void>({
      query: () => ({
        url: '/organization',
        method: 'GET',
        headers: { Accept: 'application/json' },
      }),
      providesTags: [{ type: organization, id: 'ME' }],
    }),
    patchMyOrganization: build.mutation<{ data: OrganizationSettings }, OrganizationSettingsUpdate>(
      {
        query: (body) => ({
          body,
          method: 'PATCH',
          url: '/organization',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        // the response carries the updated entity — write it into the cache
        // instead of refetching
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;
          dispatch(
            organizationApi.util.updateQueryData('getMyOrganization', undefined, (draft) => {
              draft.data = data.data;
            }),
          );
        },
      },
    ),
    patchUserOragnizationType: build.mutation<UserLoginResponse, { organization_type: string }>({
      query: (body) => {
        return {
          body,
          method: 'PATCH',
          url: `/organization/set-type`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
      invalidatesTags: [{ type: organization, id: 'ME' }],
    }),
  }),
});

export const {
  usePatchUserOragnizationTypeMutation,
  useGetMyOrganizationQuery,
  usePatchMyOrganizationMutation,
} = organizationApi;
